/**
 * EWM-942 — limits the Order Upload drawer and the `quickOrder/uploadFile` BFF
 * action must agree on.
 *
 * Shared rather than duplicated because both packages need the NUMBER, not just
 * the behaviour: the BFF enforces it and the drawer prints it. Round 2 (R2-5) —
 * the customer-facing sentence used to carry a hardcoded "5,000", so the day the
 * cap moved the copy would have lied about it.
 */

/**
 * The most rows the order-file parser will read from a worksheet, counted as a
 * 0-based row INDEX: a sheet whose last row index exceeds this is refused
 * (`UploadFileTooManyRowsError`, 413) rather than silently truncated.
 *
 * It is a hostile-input guard, not a product limit — a real order upload is
 * tens to hundreds of lines. Whether a product-level row limit is wanted on
 * both upload paths is a separate, human decision (EWM-942 follow-up 1).
 */
export const MAX_SHEET_ROWS = 5000;

/**
 * The largest order file the uploader accepts, in bytes (EWM-606's 5MB cap).
 *
 * Shared for the same reason as the row cap above, and added by the PR #1189
 * round-4 review (suggestion 8): the number was written out twice — once in the
 * BFF parser and once in the drawer — in the very PR that created this module
 * to stop exactly that drift. The BFF is the enforcer (a browser-side guard is
 * advice, not enforcement, and the request need not come from our own drawer);
 * the drawer refuses early so a customer is not made to upload 5MB to be told
 * no, and so the ~33% base64 inflation never goes on the wire.
 */
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
